export default "__VITE_ASSET__B08YYiOw__"